import { axiosInstance as axios } from "services";

export const fetchPaymentHistory = async (companyId) => {
  const { data } = await axios.get(`/admin/subscription/company/${companyId}/payment-history`);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch payment history");
  return data;
};

